import {
    CREATE_WORKSPACE,
    DELETE_WORKSPACE,
    FETCH_ACTIVE_RUNS_SUCCESS,
    FETCH_WORKSPACES,
    FETCH_WORKSPACES_FAIL,
    FETCH_WORKSPACES_SUCCESS,
    REFRESH_WORKSPACE,
    RESET_WORKSPACE,
    WORKSPACE_ACTION_FAIL,
    WORKSPACE_ACTION_SUCCESS
} from './actionTypes';
import * as _ from 'lodash';

/* busy: the keys (workspace codes, or the source code of a workspace being created) that have a call in progress. */
export const CREATE_KEY_PREFIX = 'create:';

export const initialState = {
    data: [],
    // The runs of each sandbox that are queued or running, by the code of the sandbox. Empty while they are not known.
    activeRuns: {},
    busy: {},
    error: null,
    loading: false,
    loaded: false
};

export function workspacesReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_WORKSPACES:
            return {
                ...state,
                loading: true
            };
        case FETCH_WORKSPACES_SUCCESS:
            return {
                ...state,
                data: _.sortBy(action.payload, w => w.code),
                error: null,
                loading: false,
                loaded: true
            };
        case FETCH_WORKSPACES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        case FETCH_ACTIVE_RUNS_SUCCESS:
            return {
                ...state,
                activeRuns: action.payload
            };
        case CREATE_WORKSPACE:
            return {
                ...state,
                busy: {
                    ...state.busy,
                    [CREATE_KEY_PREFIX + action.payload.sourceCode]: true
                }
            };
        case REFRESH_WORKSPACE:
        case RESET_WORKSPACE:
        case DELETE_WORKSPACE:
            return {
                ...state,
                busy: { ...state.busy, [action.payload.code]: true }
            };
        case WORKSPACE_ACTION_SUCCESS:
        case WORKSPACE_ACTION_FAIL:
            return {
                ...state,
                busy: _.omit(state.busy, action.payload.key)
            };
        default:
            return state;
    }
}
